let announcedConnectionStatus: string | null = null;

/**
 * True when a status worth announcing is seen: a change, or a first status that
 * is not the normal "internet". Being connected when the app opens is the
 * expected state, so it is recorded without a toast; going offline, slow or
 * limited at start, and every later change including coming back, still toast.
 */
export function claimConnectionToast(status: string): boolean {
  if (status === "unknown" || status === announcedConnectionStatus) {
    return false;
  }
  const isFirstStatus = announcedConnectionStatus === null;
  announcedConnectionStatus = status;
  return !(isFirstStatus && status === "internet");
}

export function resetAnnouncedConnectionStatus(): void {
  announcedConnectionStatus = null;
}
